import { apiChatbot } from '@spo/services/api';
import {
  PostApiSpoChatbotBodyMessagesItem,
  PostApiSpoChatbotRatingBodyMessagesItem,
} from '@spo/types';
import { useMutation } from '@tanstack/react-query';

export const useChatbot = (
  messages: PostApiSpoChatbotBodyMessagesItem[],
  onSuccess: (response: string) => void,
) => {
  return useMutation({
    mutationKey: ['useChatbot', messages],
    mutationFn: (msgs: PostApiSpoChatbotBodyMessagesItem[]) =>
      apiChatbot.sendMsgToChatbot(msgs),
    onSuccess,
  });
};

export const useChatbotRating = (
  messages: PostApiSpoChatbotRatingBodyMessagesItem[],
  rating: string,
  comment: string,
  onSuccess: () => void,
  onError: () => void,
) => {
  return useMutation({
    mutationKey: ['useChatbotRating', messages, rating, comment],
    mutationFn: () =>
      apiChatbot.sendFeedbackToChatbot({ messages, rating, comment }),
    onSuccess,
    onError,
  });
};
